import { axios } from "../Support/Axios";
import { HttpForm } from "../Support/HttpForm";
class SanctumAuthentication extends HttpForm {
    data = {
        email: null,
        password: null,
        remember: false
    };
    passwordFieldType = 'password';
    csrfEndpoint = '/sanctum/csrf-cookie';
    loginEndpoint = '/login';
    logoutEndpoint = '/logout';
    applicationEndpoint = '/admin';
    mfa = false;
    mfa_recovery = false;
    generateCsrfCookie() {
        return axios.get(this.csrfEndpoint);
    }
    sendLoginRequest(data) {
        return axios.post(this.loginEndpoint, data);
    }
}
class Authentication extends SanctumAuthentication {
    signIn() {
        this.resetErrorStatus();
        return this.generateCsrfCookie()
            .then(() => this.sendLoginRequest(this.data).then((response) => {
            this.mfa = response.data.mfa;
            if (!this.mfa) {
                this.redirectToApplication();
            }
        })).catch(e => this.setError(e));
    }
    sendMfaCheck() {
        const url = '/submit-two-factor';
        return axios.post(url, this.data)
            .then(() => this.redirectToApplication())
            .catch(e => this.setError(e));
    }
    mfaRecovery() {
        this.mfa_recovery = true;
    }
    signOut() {
        return axios.post(this.logoutEndpoint)
            .then(() => window.location.href = this.loginEndpoint)
            .catch(e => this.setError(e));
    }
    togglePasswordFieldType() {
        this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        return this.passwordFieldType;
    }
    forgotPassword() {
        const url = '/forgot-password';
        this.resetFormMessages();
        return axios.post(url, this.data)
            .then((r) => {
            this.setSuccessMessage(r.data.message);
        })
            .catch(e => this.setError(e));
    }
    resetPassword() {
        const url = '/reset-password';
        this.resetFormMessages();
        return axios.post(url, this.data)
            .then((r) => {
            this.navigation.toRouteName('login');
        })
            .catch(e => this.setError(e));
    }
    redirectToApplication() {
        return window.location.href = this.applicationEndpoint;
    }
}
export { Authentication };
